import request from '../utils/request';
import { REST_SERVICE } from '../config';

// 打印企业证书证明
// export const printQyDjzs = (params) =>{
//     return request({
//       url: REST_SERVICE.print.printQyDjzs,
//       method: 'post',
//       params
//     });
//   }

// 电子证照查询
export const queryCeritificateList = (data) =>
  request({
    url: REST_SERVICE.dzzz.queryCeritificateList,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  });

// 2.4 电子证照查验
export const verifyCeritificate = (params) =>
  request({
    url: REST_SERVICE.dzzz.verifyCeritificate,
    method: 'post',
    params
  });

// 2.3通过共享交换下载电子证照文件
export const downloadCeritificate = (data) =>
  request({
    url: REST_SERVICE.dzzz.downloadCeritificate,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  });
